export default "__VITE_ASSET__DuNCZqDY__"